import { render } from "./SendAct.vue?vue&type=template&id=4eaa76c7"
import script from "./SendAct.vue?vue&type=script&lang=js"
export * from "./SendAct.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__